export const autoWidth = 'auto';
export const nonBreakingSpace = '&nbsp;';
export const imageAssetsBasePath = '/assets/images';
export const googleMapsApiKey = 'AIzaSyCRLQKFHfORtq4hhAjiM4IEE1gPAbk1tcw';
